<template>
    <div>
        <div class="footerTitle">
                <ul>
                    <li :style="{width:width+'px'}"><slot></slot></li>
                    <li :style="{width:width+'px'}"></li>
                </ul>
            </div>

    </div>
</template>
<script>
export default {
    props:{
        width:{
            type:Number,
            default:122
        }
    }
}
</script>
<style lang="scss" scoped>
.footerTitle {
        // width: 884px;
        height: 100%;
        height: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 30px;
        margin-top: 30px;
        ul {
            height: 50px;
            position: relative;
            li:first-child{
                width: 122px;

                font-size: 25px;
                font-weight: bold;
                text-align: center;
                position: absolute;
                top:-15px;
                left: 0;
                }
            li:last-child {
                width: 122px;
                height: 13px;
                background: #f9b78a;
                border-radius: 15px;
            }
        }
    }
</style>